import {
  IFieldType,
  IFormSchema,
  IAutocomplete,
  IFormField,
} from "shared/types";
import { copy } from "shared/assets";
import { PASSWORD_MIN_LENGTH } from "Auth/utils";

const { errors, authFormFields } = copy;

export const makeSchema = (
  requireOldPassword: boolean,
  handleClose: () => void
): IFormSchema => ({
  fields: getFields(requireOldPassword),
  buttons: {
    primary: {
      children: copy.changePassword.button,
    },
    secondary: {
      onClick: handleClose,
    },
  },
});

const getFields = (requireOldPassword: boolean): IFormField[] => {
  const newPasswordFields: IFormField[] = [
    {
      name: "newPassword",
      label: authFormFields.newPassword,
      type: IFieldType.password,
      note: authFormFields.password.note.replace(
        "%s",
        PASSWORD_MIN_LENGTH.toString()
      ),
      autocomplete: IAutocomplete.newPassword,
      validation: {
        required: errors.required,
        minLength: {
          value: PASSWORD_MIN_LENGTH,
          message: errors.password.length,
        },
      },
    },
    {
      name: "confirmNewPassword",
      label: authFormFields.confirmNewPassword,
      type: IFieldType.password,
      autocomplete: IAutocomplete.newPassword,
      validation: {
        required: errors.required,
        match: {
          name: "newPassword",
          message: errors.password.match,
        },
      },
    },
  ];

  if (requireOldPassword) {
    return [
      {
        name: "oldPassword",
        label: authFormFields.currentPassword,
        type: IFieldType.password,
        autocomplete: IAutocomplete.currentPassword,
        validation: {
          required: errors.required,
        },
      },
      ...newPasswordFields,
    ];
  }

  return newPasswordFields;
};
